import CreateSurveyButton from "@pulse/features/dashboard/DashboardHeader/CreateSurveyButton";
import OverviewArea from "@pulse/features/dashboard/Overview/OverviewArea";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId/")({
    component: RouteComponent,
    staticData: {
        titleFn: (t) => t("title.overview"),
    },
});

function RouteComponent() {
    return (
        <>
            <CreateSurveyButton />
            <OverviewArea />
        </>
    );
}
